let initialized = false;

const measurementId = 'G-VPY912SNJW';

export const initAnalytics = () => {
  if (initialized) return;

  // GTM loader (ONLY THIS)
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  initialized = true;
};


export const trackPageView = () => {
  return (
    <>
      {/* Google Tag Manager (noscript) */}
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MQZ53R7X"
      height="0" width="0" style={{display:'none',visibility:'hidden'}}></iframe></noscript>
      {/* End Google Tag Manager (noscript) */}
    </>
  )
};